<div class="page">

  <!-- Header -->
  <div class="checklist-header">
    <h1 class="header-title">Contact Admin</h1>
  </div>
  

  <!-- ── Body: Sidebar + Main ── -->
  <div class="ca-body">

    

    <!-- ── Main: Two-panel layout ── -->
    <div class="ca-main">

      <!-- Left Panel: Request List -->
      <div class="ca-list-panel">
        <div class="ca-list-header">
          <span class="ca-list-title">My requests</span>
          <button class="ca-new-btn" (click)="openNewRequest()">+ New</button>
        </div>

        <div class="ca-search-wrap">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="ca-search-icon"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
          <input
            type="text"
            placeholder="Search requests..."
            [(ngModel)]="searchQuery"
            (ngModelChange)="applyFilter()"
            class="ca-search-input"
          />
        </div>

        <!-- Filter tabs -->
        <div class="ca-filter-tabs">
          <button *ngFor="let t of filterTabs" (click)="setFilter(t.key)" class="ca-filter-tab" [class.ca-filter-active]="activeFilter === t.key">
            {{ t.label }} ({{ t.count }})
          </button>
        </div>

         <div class="ca-request-list">
          <div
            *ngFor="let req of filteredRequests"
            class="ca-request-item"
            [class.ca-request-selected]="selectedRequest?.id === req.id"
            (click)="selectRequest(req)"
          >
            <div class="ca-req-icon" [ngClass]="req.type === 'death' ? 'ca-req-icon-death' : 'ca-req-icon-general'">
              <svg *ngIf="req.type === 'death'" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="12" y1="18" x2="12" y2="12"/><line x1="9" y1="15" x2="15" y2="15"/></svg>
              <svg *ngIf="req.type === 'general'" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
            </div>
            <div class="ca-req-info">
              <p class="ca-req-title">{{ req.title }}</p>
              <p class="ca-req-account">{{ req.accountName }}</p>
              <div class="ca-req-badges">
                <span class="ca-badge" [ngClass]="req.type === 'death' ? 'ca-badge-death' : 'ca-badge-general'">
                  {{ req.type === 'death' ? 'Death report' : 'General' }}
                </span>
                <span class="ca-badge" [ngClass]="{
                  'ca-badge-pending':  req.status === 'Pending',
                  'ca-badge-approved': req.status === 'Approved',
                  'ca-badge-pending-review': req.status === 'Pending review'
                }">{{ req.status }}</span>
              </div>
              <p class="ca-req-date">{{ req.date | date:'d MMM yyyy' }}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Right Panel: Detail / New Request Form -->
      <div class="ca-detail-panel">

        <!-- ── NEW REQUEST: type picker ── -->
        <ng-container *ngIf="view === 'new-picker'">
          <div class="ca-detail-header">
         <button class="ca-back-btn" (click)="goToRequestSelection()">← Back</button>
            <h2 class="ca-detail-title">New request</h2>
          </div>
          <div class="ca-type-cards">
            <div class="ca-type-card" [class.ca-type-card-selected]="newRequestType === 'general'" (click)="selectNewType('general')">
              <div class="ca-type-card-icon ca-type-card-icon-general">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
              </div>
              <p class="ca-type-card-title">General support</p>
              <p class="ca-type-card-desc">Login issues, missing content, technical problems</p>
            </div>
            <!-- <div class="ca-type-card" [class.ca-type-card-selected]="newRequestType === 'death'" (click)="selectNewType('death')">
              <div class="ca-type-card-icon ca-type-card-icon-death">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="12" y1="18" x2="12" y2="12"/><line x1="9" y1="15" x2="15" y2="15"/></svg>
              </div>
              <p class="ca-type-card-title">Report a passing</p>
              <p class="ca-type-card-desc">Submit documents to unlock full legacy access</p>
            </div> -->
          </div>
        </ng-container>

        <!-- ── NEW REQUEST: General support form ── -->
        <ng-container *ngIf="view === 'new-general'">
          <div class="ca-detail-header">
            <button
  class="ca-back-btn"
  (click)="goBack()">
  ← Back
</button>
            <h2 class="ca-detail-title">New request</h2>
          </div>
          <!-- <div class="ca-type-cards">
            <div class="ca-type-card ca-type-card-selected" (click)="selectNewType('general')">
              <div class="ca-type-card-icon ca-type-card-icon-general">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
              </div>
              <p class="ca-type-card-title">General support</p>
              <p class="ca-type-card-desc">Login issues, missing content, technical problems</p>
            </div>
            <div class="ca-type-card" (click)="selectNewType('death')">
              <div class="ca-type-card-icon ca-type-card-icon-death">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="12" y1="18" x2="12" y2="12"/><line x1="9" y1="15" x2="15" y2="15"/></svg>
              </div>
              <p class="ca-type-card-title">Report a passing</p>
              <p class="ca-type-card-desc">Submit documents to unlock full legacy access</p>
            </div>
          </div> -->
          <div class="ca-form">
            <div class="ca-form-group">
              <label class="ca-form-label">Issue type</label>
             <div class="ca-custom-dropdown">

  <button
    type="button"
    class="ca-dropdown-btn"
    (click)="generalIssueDropdownOpen = !generalIssueDropdownOpen">

    {{ selectedIssueLabel }}

    <span>⌄</span>

  </button>

  <div
    *ngIf="generalIssueDropdownOpen"
    class="ca-dropdown-menu">

    <button
  type="button"
  (click)="selectIssueType('cant-access')">
  Can't access account / login problem
</button>
   <button
  type="button"
  (click)="selectIssueType('missing-content')">
  Missing content
</button>

<button
  type="button"
  (click)="selectIssueType('technical')">
  Technical problem
</button>

<button
  type="button"
  (click)="selectIssueType('other')">
  Other
</button>

  </div>

</div>
            </div>
            <div class="ca-form-group">
  <label class="ca-form-label">Account holder's name</label>
  <input
    type="text"
    [value]="viewingAs"
    class="ca-form-input"
    readonly
  />
</div>
            <div class="ca-form-group">
              <label class="ca-form-label">Describe your issue</label>
              <textarea [(ngModel)]="generalForm.description" placeholder="Please describe what you're experiencing..." class="ca-form-textarea"></textarea>
            </div>
            <div class="ca-form-actions">
              <button
  class="ca-submit-btn"
  (click)="submitGeneralRequest()"
  [disabled]="!isGeneralFormValid()">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>
                Submit request
              </button>
              <button class="ca-cancel-btn" (click)="goBack()">Cancel</button>
            </div>
          </div>
        </ng-container>

        <!-- ── NEW REQUEST: Death report form ── -->
        <ng-container *ngIf="view === 'new-death'">
          <div class="ca-detail-header">
            <button class="ca-back-btn" (click)="view = 'new-picker'; newRequestType = null">← Back</button>
            <h2 class="ca-detail-title">New request</h2>
          </div>
          <!-- <div class="ca-type-cards">
            <div class="ca-type-card" (click)="selectNewType('general')">
              <div class="ca-type-card-icon ca-type-card-icon-general">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
              </div>
              <p class="ca-type-card-title">General support</p>
              <p class="ca-type-card-desc">Login issues, missing content, technical problems</p>
            </div>
            <div class="ca-type-card ca-type-card-selected" (click)="selectNewType('death')">
              <div class="ca-type-card-icon ca-type-card-icon-death">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="12" y1="18" x2="12" y2="12"/><line x1="9" y1="15" x2="15" y2="15"/></svg>
              </div>
              <p class="ca-type-card-title">Report a passing</p>
              <p class="ca-type-card-desc">Submit documents to unlock full legacy access</p>
            </div>
          </div> -->
          <!-- Info banner -->
          <div class="ca-info-banner">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#c2410c" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
            Once verified, your checklist and all legacy documents will be unlocked. This usually takes 1–2 business days.
          </div>
          <div class="ca-form">
         <div class="ca-form-group">
  <label class="ca-form-label">Account holder's name</label>
  <input
    type="text"
    [value]="viewingAs"
    class="ca-form-input"
    readonly
  />
</div>
            <div class="ca-form-group">
              <label class="ca-form-label">Your relationship</label>
             <div class="ca-custom-dropdown">

  <button
    type="button"
    class="ca-dropdown-btn"
    (click)="relationshipDropdownOpen = !relationshipDropdownOpen">
    {{ selectedRelationshipLabel }}
    <span>⌄</span>
  </button>

  <div
    *ngIf="relationshipDropdownOpen"
    class="ca-dropdown-menu">

    <button type="button" (click)="selectRelationship('spouse')">
      Spouse / Partner
    </button>

    <button type="button" (click)="selectRelationship('child')">
      Child
    </button>

    <button type="button" (click)="selectRelationship('parent')">
      Parent
    </button>

    <button type="button" (click)="selectRelationship('sibling')">
      Sibling
    </button>

    <button type="button" (click)="selectRelationship('executor')">
      Executor
    </button>

    <button type="button" (click)="selectRelationship('other')">
      Other
    </button>

  </div>

</div>
            </div>
            <div class="ca-form-group">
              <label class="ca-form-label">Date of passing</label>
              <input type="date" [(ngModel)]="deathForm.dateOfPassing" class="ca-form-input" />
            </div>
            <div class="ca-form-group">
              <label class="ca-form-label">Upload death certificate</label>
              <div class="ca-upload-box" (click)="certFileInput.click()">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="16 16 12 12 8 16"/><line x1="12" y1="12" x2="12" y2="21"/><path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3"/></svg>
                <p class="ca-upload-text">Click to upload or drag &amp; drop</p>
                <p class="ca-upload-hint">PDF, JPG, PNG — max 10 MB</p>
                <input #certFileInput type="file" accept=".pdf,.jpg,.png" style="display:none" (change)="onCertUpload($event)" />
              </div>
              <p *ngIf="deathForm.certFileName" class="ca-upload-file-name">✓ {{ deathForm.certFileName }}</p>
            </div>
            <div class="ca-form-group">
              <label class="ca-form-label">Additional documents <span class="ca-optional">(optional)</span></label>
              <div class="ca-upload-box ca-upload-box-sm" (click)="addlFileInput.click()">
                <p class="ca-upload-text-sm">Legal ID, probate documents, executor letter</p>
                <input #addlFileInput type="file" accept=".pdf,.jpg,.png" style="display:none" (change)="onAddlUpload($event)" />
              </div>
            </div>
            <div class="ca-form-group">
              <label class="ca-form-label">Additional notes <span class="ca-optional">(optional)</span></label>
              <textarea [(ngModel)]="deathForm.notes" placeholder="Anything else the admin should know..." class="ca-form-textarea"></textarea>
            </div>
            <div class="ca-form-actions">
             <button
  class="ca-submit-btn"
  (click)="submitDeathRequest()"
  [disabled]="!isDeathFormValid()">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>
                Submit for review
              </button>
              <button class="ca-cancel-btn" (click)="goBack()">Cancel</button>
            </div>
          </div>
        </ng-container>

        <!-- ── DETAIL VIEW ── -->
        <ng-container *ngIf="view === 'detail' && selectedRequest">

          <!-- Death report detail -->
          <ng-container *ngIf="selectedRequest.type === 'death'">
            <div class="ca-detail-top">
              <div class="ca-detail-badges">
                <span class="ca-badge ca-badge-death-outline">
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
                  Death report
                </span>
                <span class="ca-badge" [ngClass]="{
                  'ca-badge-pending': selectedRequest.status === 'Pending',
                  'ca-badge-pending-review': selectedRequest.status === 'Pending review',
                  'ca-badge-approved': selectedRequest.status === 'Approved'
                }">{{ selectedRequest.status }}</span>
              </div>
              <div class="ca-expected-box">
                <p class="ca-expected-label">Expected review</p>
                <p class="ca-expected-value">1–2 business days</p>
              </div>
            </div>
            <h2 class="ca-req-detail-title">{{ selectedRequest.title }}</h2>
            <p class="ca-req-detail-meta">Submitted {{ selectedRequest.date | date:'d MMM yyyy' }} · {{ selectedRequest.accountName }}</p>

            <p class="ca-section-label">REQUEST DETAILS</p>
            <div class="ca-detail-grid-2">
              <div class="ca-detail-field">
                <p class="ca-detail-field-label">Account holder</p>
                <p class="ca-detail-field-value">{{ selectedRequest.accountHolder }}</p>
              </div>
              <div class="ca-detail-field">
                <p class="ca-detail-field-label">Relationship</p>
                <p class="ca-detail-field-value">{{ selectedRequest.relationship }}</p>
              </div>
              <div class="ca-detail-field">
                <p class="ca-detail-field-label">Date of passing</p>
                <p class="ca-detail-field-value">{{ selectedRequest.dateOfPassing | date:'d MMM yyyy' }}</p>
              </div>
              <div class="ca-detail-field">
                <p class="ca-detail-field-label">Request ID</p>
                <p class="ca-detail-field-value">{{ selectedRequest.requestId }}</p>
              </div>
            </div>

            <p class="ca-section-label">YOUR NOTE</p>
            <div class="ca-note-box">
              "{{ selectedRequest.note }}"
            </div>

            <p class="ca-section-label">UPLOADED DOCUMENTS</p>
            <div class="ca-docs-list">
              <div class="ca-doc-item" *ngFor="let doc of selectedRequest.documents">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#2563eb" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
                <div class="ca-doc-info">
                  <a href="#" class="ca-doc-name">{{ doc.name }}</a>
                  <p class="ca-doc-meta">{{ doc.label }} · {{ doc.size }}</p>
                </div>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="ca-doc-ext"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/></svg>
              </div>
            </div>

            <div class="ca-unlock-banner">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#c2410c" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
              Once approved, your checklist and all legacy documents for {{ selectedRequest.accountName }} will be unlocked automatically.
            </div>
          </ng-container>

          <!-- General support detail -->
          <ng-container *ngIf="selectedRequest.type === 'general'">
            <div class="ca-detail-top">
              <div class="ca-detail-badges">
                <span class="ca-badge ca-badge-general-outline">General support</span>
                <span class="ca-badge ca-badge-pending">{{ selectedRequest.status }}</span>
              </div>
              <div class="ca-expected-box">
                <p class="ca-expected-label">Expected review</p>
                <p class="ca-expected-value">1–2 business days</p>
              </div>
            </div>
            <h2 class="ca-req-detail-title">{{ selectedRequest.title }}</h2>
            <p class="ca-req-detail-meta">Submitted {{ selectedRequest.date | date:'d MMM yyyy' }} · {{ selectedRequest.accountName }} · {{ selectedRequest.requestId }}</p>

            <p class="ca-section-label">REQUEST DETAILS</p>
            <div class="ca-detail-field ca-detail-field-full">
              <p class="ca-detail-field-label">Issue type</p>
              <p class="ca-detail-field-value">{{ selectedRequest.issueType }}</p>
            </div>
            <div class="ca-detail-grid-2" style="margin-top:12px;">
              <div class="ca-detail-field">
                <p class="ca-detail-field-label">Account holder</p>
                <p class="ca-detail-field-value">{{ selectedRequest.accountHolder }}</p>
              </div>
              <div class="ca-detail-field">
                <p class="ca-detail-field-label">Request ID</p>
                <p class="ca-detail-field-value">{{ selectedRequest.requestId }}</p>
              </div>
            </div>

            <p class="ca-section-label">YOUR DESCRIPTION</p>
            <div class="ca-note-box ca-note-italic">
              {{ selectedRequest.note }}
            </div>

            <div class="ca-awaiting-box">
              Awaiting response from the Continuum team. We typically respond within 1–2 business days.
            </div>
          </ng-container>

        </ng-container>

        <!-- ── EMPTY state ── -->
        <ng-container *ngIf="view === 'empty'">
          <div class="ca-empty-state">
            <p class="ca-empty-text">Select a request to view details, or create a new one.</p>
          </div>
        </ng-container>

      </div>
    </div>
  </div>
</div>